export const accessTokenCookieName = 'jat';

export const idTokenCookieName = 'auth';

export const pkceVerifierCookieName = 'pkce_verifier';

export const authorizeEndpoint = process.env.REACT_APP_AUTHORIZE_URL || 'https://app.janisdev.in/oauth/authorize';

export const tokenEndpoint = process.env.REACT_APP_TOKEN_URL || 'https://id.janisdev.in/api/oauth/2.0/token';

export const jwksUri = process.env.REACT_APP_JWKS_URL || 'https://cdn.id.janisdev.in/.well-known/jwks.json';

export const oauthClientId = process.env.REACT_APP_OAUTH_CLIENT_ID || '3c32009a-c729-42f7-9920-93d23434862f';

export const oauthRedirectPath = '/oauth/callback';
